import React from 'react';
import MuiTextField, { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';

export type TextFieldProps = Omit<MuiTextFieldProps, 'variant'>;

export const TextField = React.forwardRef<HTMLDivElement, TextFieldProps>((props, ref) => {
  return <MuiTextField fullWidth={true} {...props} variant='outlined' ref={ref} />;
});
